import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import CustomDialog from "Components/CustomDialog/CustomDialog";
import { useState } from "react";

function SamlAdminSetupDialog() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button variant="outlined" onClick={() => setOpen(true)}>
        Admin setup instructions
      </Button>

      <CustomDialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>SSO onboarding (for admins)</DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.secondary" mb={2}>
            Reply URLs include the Incendium SSO tenant id. That tenant must
            exist before you can generate instructions for your client&apos;s
            Microsoft Entra SAML configuration.
          </Typography>

          <Box component="ol" sx={{ pl: 2.5, m: 0 }}>
            <Typography component="li" variant="body2" gutterBottom>
              Discuss with your client and decide on an enterprise application
              name (Entity ID).
            </Typography>
            <Typography component="li" variant="body2" gutterBottom>
              Create the SSO tenant in Incendium&apos;s super admin:
              enter the Entity ID and the email domain. Leave the Federation
              metadata URL empty for now.
            </Typography>
            <Typography component="li" variant="body2" gutterBottom>
              Save the tenant, then use the icon next to that tenant to
              open the client setup steps (Reply URL is tenant-specific).
            </Typography>
            <Typography component="li" variant="body2">
              When the client sends back the Federation metadata URL, edit
              the tenant and paste it in to complete SSO configuration.
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Close</Button>
        </DialogActions>
      </CustomDialog>
    </>
  );
}

export default SamlAdminSetupDialog;

